export const SET_TELEMETRY_ENTRIES = "SET_TELEMETRY_ENTRIES";
export const SET_LOADING = "SET_LOADING";
